import React, { useState } from "react";
import styles from "./Donate.module.css";
import StripeContainer from "../../components/StripeContainer";

export default function DonationForm() {
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [customAmount, setCustomAmount] = useState("");
  const amount = customAmount !== "" ? +customAmount : selectedAmount;
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
  });

  const quickAmounts = [25, 50, 100, 250, 500, 1000];

  const handleAmountClick = (amount) => {
    setSelectedAmount(amount);
    setCustomAmount("");
  };

  const handleCustomAmountChange = (e) => {
    setCustomAmount(e.target.value);
    setSelectedAmount(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const { format } = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  return (
    <div className={styles.formContainer}>
      <h1 className={styles.mainTitle}>Make Your Donation</h1>
      <div className={styles.donationForm}>
        <form>
          {/* Quick Amount Selection */}
          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Choose Your Donation Amount</h2>
            <div className={styles.amountGrid}>
              {quickAmounts.map((amount) => (
                <button
                  key={amount}
                  type="button"
                  className={`${styles.amountBtn} ${
                    selectedAmount === amount ? styles.selected : ""
                  }`}
                  onClick={() => handleAmountClick(amount)}
                >
                  ${amount}
                </button>
              ))}
            </div>
          </section>

          {/* Custom Amount */}
          <section className={styles.section}>
            <div className={styles.customAmountRow}>
              <label
                htmlFor="customAmount"
                className={styles.customAmountLabel}
              >
                Custom Amount:
              </label>
              <input
                type="number"
                id="customAmount"
                className={styles.customAmountInput}
                placeholder="Enter amount"
                value={customAmount}
                onChange={handleCustomAmountChange}
              />
            </div>
          </section>
          <br />
          <br />

          {/* Donor Information */}
          <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Donor Information</h2>

            <div className={styles.nameGrid}>
              <div className={styles.formGroup}>
                <label htmlFor="firstName">First Name</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  className={styles.formInput}
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className={styles.formGroup}>
                <label htmlFor="lastName">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  className={styles.formInput}
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                className={styles.formInput}
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
          </section>
        </form>
        <section className={styles.section}>
          <h3 className={styles.amountText}>Amount: {format(amount)}</h3>
        </section>
        <br />
        <br />
        {/* Card Information */}
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Card Information:</h2>
          <StripeContainer formData={formData} amount={amount} />
        </section>
      </div>
    </div>
  );
}
